import { render } from "./Idle.vue?vue&type=template&id=30497530&scoped=true"
import script from "./Idle.vue?vue&type=script&lang=js"
export * from "./Idle.vue?vue&type=script&lang=js"

import "./Idle.vue?vue&type=style&index=0&id=30497530&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30497530"]])

export default __exports__